module.exports = __webpack_public_path__ + "static/media/faqimg01.91acf58b.png";